import * as React from 'react';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

import DriversPage from '&/features/settings/drivers/pages/drivers-page';

export const Route = createFileRoute('/_authenticated/settings_/spaces/$spaceId/drivers')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['spaces:manage', 'spaces:access-read-only'])
    ) {
      throw redirect({ params: { spaceId: params.spaceId }, to: '/settings/spaces/$spaceId' });
    }
  },
  component: SpaceDriversPage,
});

// Scope comes from the route params, not the master context: the breadcrumb scope can point
// to a different space when browsing into a space's settings via the spaces list, which would
// query the wrong space and mis-lock the driver drawer's scope selector.
function SpaceDriversPage(): React.JSX.Element {
  const { spaceId } = useParams({ from: '/_authenticated/settings_/spaces/$spaceId/drivers' });
  return <DriversPage spaceId={spaceId} />;
}
